import $ from 'jquery';
import 'jquery.hotkeys';
import {fitText, shuffleArray, swapInArray} from "./playUtil.es6";
import Texter from "./texter.es6";
import PlayProgressBar from "./playProgressBar.es6";
import CardSound from "./cardSound.es6";
import mapElementToValue from "./mapElementToValue.es6";
import stopEvent from "./stopEvent.es6";

// const log = console.log;
const log = $.noop;

class PackPlay {
    constructor(opts) {
        const l18n = Texter.create(opts.l18n);
        const playList = opts.playList;
        const playProgressBar = new PlayProgressBar(opts.playProgress, l18n);

        this.playControls = opts.playControls;
        this.views = playList.find('.play-card-stack__card');

        const modeChanged = (mode) => {
            $('#playTurn').prop('disabled', mode === 'both');
            this.playControls.find('[data-click=showBoth]')
                .toggleClass('active', mode === 'both')
                .attr('aria-pressed', mode === 'both');
            playList.toggleClass('play-card-stack--both-faces', mode === 'both');
        };

        const progresser = (progress) => {
            const currentNumber = this.currentIndex + 1;
            var percent = progress.total > 0 ? (currentNumber / progress.total) : 1;

            playProgressBar.text = `${currentNumber} / ${progress.total}`;
            playProgressBar.percent = percent * 100;

            this.playControls.find('[data-bind=playIndex]').text(l18n.get('packPlay.progressTemplate')
                .replace(/\{0\}/g, currentNumber)
                .replace(/\{1\}/g, progress.total));
        };

        this.currentList = [];
        this.currentIndex = -1;
        this.currentView = null;
        this.currentSide = '';

        this.displayMode = 'side';
        this.displayModeChanged = () => {
            modeChanged(this.displayMode);
            if (this.currentView !== null) {
                this._fitSideText($(this.currentView));
            }
        };

        this.cardOutAnim = 'fadeOutUp';

        CardSound.addReadyCallback(() => {
            playList.addClass('play-card-stack--speakable');
        });

        const audioSupplier = button => CardSound.singleSideButton(button, $(button).closest('.play-card-stack__card-side'));
        const audioCache = mapElementToValue('audio-cache', audioSupplier);

        playList.on('click', 'button[data-click=sayText]', e => {
            audioCache.get(e.currentTarget).toggle();
            return stopEvent(e);
        });

        playList.on('click', '.play-card-stack__card-face', e => {
            this._onCardClick();
            return false;
        });
        playList.on('click', '.play-card-stack__card-back', e => {
            this._onCardClick();
            return false;
        });

        this.progresser = $.isFunction(progresser) ? progresser : $.noop;
        this.progress = {
            total: this.views.length,
            passed: 0,

            increment: function () {
                this.passed += 1;
                if (this.passed > this.total) {
                    this.passed = 1;
                }
            }
        };

        this.displayModeChanged();

        function bindShortcut(button, key, func) {
            $(document).on('keypress', null, key, func);
            $(button).click(func);
        }

        bindShortcut(this.playControls.find('[data-click=playPrev]'), 'p з', this.prev.bind(this));
        bindShortcut(this.playControls.find('[data-click=playNext]'), 'n т', this.next.bind(this));
        bindShortcut('#playTurn', 'f а', this.turn.bind(this));
        bindShortcut(this.playControls.find('[data-click=playShuffle]'), 's ы', this.shuffle.bind(this));
        bindShortcut(this.playControls.find('[data-click=showBoth]'), 'b и', this.toggleBoth.bind(this));
    }

    _shuffle() {
        let lastLast = null;
        if (this.currentList.length > 0) {
            lastLast = this.currentList[this.currentList.length - 1];
        }

        this.currentList = [];
        for (let i = 0; i < this.views.length; ++i) {
            this.currentList.push(this.views.get(i));
        }

        shuffleArray(this.currentList);

        if (lastLast !== null && this.currentList.length > 0 && lastLast === this.currentList[0]) {
            swapInArray(this.currentList, 0, this.currentList.length - 1);
        }
    }

    stopSpeak() {
        CardSound.stop();
    }

    start() {
        this.stopSpeak();
        this.progress.passed = 0;
        this._currentViewDiscard();
        this._display(this._next());
        this._fireProgress();
    }

    next() {
        this.stopSpeak();
        if (this._isBothDisplayMode()) {
            this._display(this._next());
        } else {
            if (this.currentSide === 'front') {
                this._displayFace(false);
                this._displayBack(true);
            } else {
                this._display(this._next());
            }
        }
    }

    turn() {
        if (this._isBothDisplayMode()) {
            return;
        }

        this.stopSpeak();

        if (this.currentSide === 'back') {
            this._displayBack(false);
            this._displayFace(true);
        } else {
            this._displayFace(false);
            this._displayBack(true);
        }
    }

    prev() {
        this.stopSpeak();

        if (this._isBothDisplayMode()) {
            this._display(this._prev());
        } else {
            if (this.currentSide === 'back') {
                this._displayFace(true);
                this._displayBack(false);
            } else {
                this._display(this._prev());
            }
        }
    }

    _prev() {
        this.currentIndex = (this.currentIndex - 1 + this.views.length) % this.views.length;
        if (this.currentIndex === this.views.length - 1) {
            this._shuffle();
        }
        return this.currentList[this.currentIndex];
    }

    _next() {
        this.currentIndex = (this.currentIndex + 1) % this.views.length;
        if (this.currentIndex === 0) {
            this._shuffle();
        }
        return this.currentList[this.currentIndex];
    }

    _needHideAnimation(view) {
        return $(view).css('position') === 'absolute';
    }

    _needFitText(view) {
        // return $(view).css('position') === 'absolute';
        return true;
    }

    _currentViewDiscard() {
        if (this.currentView === null) {
            return;
        }

        const last = $(this.currentView);
        const hider = function () {
            last.hide();
        };

        if (this._needHideAnimation(last)) {
            last.animateCss(this.cardOutAnim, hider);
        } else {
            hider();
        }
        this.currentView = null;
    }

    _display(view) {
        if (this.currentView === view) {
            this._displayFace(true);
            this._displayBack(this._isBothDisplayMode());
            return;
        }

        this._currentViewDiscard();

        if (view !== null) {
            this.currentView = view;
            const current = $(view);
            current.show();
            current.animateCssStop(this.cardOutAnim);

            this._displayFace(true);
            this._displayBack(this._isBothDisplayMode());

            this.progress.increment();
            this._fireProgress();
        }
    }

    _onCardClick() {
        this.next();
    }

    _fitSideText(side) {
        if (this._needFitText(this.currentView)) {
            fitText(side.find('.play-card-stack__card-text > div'), .7);
        }
        side.find('.play-card-stack__card-image > img').fitImage();
    }

    _displayFace(visible) {
        const side = $(this.currentView).find('.play-card-stack__card-face');
        if (visible) {
            this.currentSide = 'front';
            side.show();
            this._fitSideText(side);
        } else {
            side.hide();
        }
    }

    _displayBack(visible) {
        const side = $(this.currentView).find('.play-card-stack__card-back');
        if (visible) {
            this.currentSide = 'back';
            side.show();
            this._fitSideText(side);
        } else {
            side.hide();
        }
    }

    _fireProgress() {
        this.progresser(this.progress);
    }

    shuffle() {
        this._shuffle();
        this.currentIndex = -1;
        this.start();
    }

    _isBothDisplayMode() {
        return this.displayMode === 'both';
    }

    toggleBoth() {
        if (this.displayMode === 'side') {
            this.displayMode = 'both';
            this._displayFace(true);
            this._displayBack(true);
        } else {
            this.displayMode = 'side';
            this._displayFace(true);
            this._displayBack(false);
        }
        this.displayModeChanged();
    }
}

global.PackPlay = PackPlay;